import { faSpiderBlackWidow } from "@fortawesome/pro-light-svg-icons";
import "./CategorySelectionContainer.css";
import React, { Component, useState, useEffect, useContext } from "react";
import sourceData from "./sourceData";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-light-svg-icons";
import { CustomAggregateFunction } from "./CustomAggregateFunction";
import { manageMapperStore } from "../../../contexts";
import { isEmpty, get, isNull } from "lodash";
import { AddToolTip } from "../../../components";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { useRouterParams } from "../../../abstracts";

const CategorySelectionContainer = ({
  fields,
  values,
  setValues,
  setFieldValue,
  aggregateData,
  setAggregateData,
}) => {
  // Getting the data from DB using the API
  const { state, dispatch } = useContext(manageMapperStore);
  const { mapType } = useRouterParams();
  // const [customFields, setCustomFields] = useState([]);
  const customFields = values.aggregationOperationEntities;
  const aggregationStrategy = values.aggregationStrategy;
  // Populates the aggregationOperationEntities with the use of fields
  useEffect(() => {
    setAggregateData(customFields);
  }, [values]);
  useEffect(() => {
    if (aggregationStrategy == "1" || aggregationStrategy == "2")
      setFieldValue(
        "aggregationOperationEntities",
        fields?.map((item) => {
          return {
            ...item,
            operation: aggregationStrategy == "1" ? "First" : "Last",
          };
        })
      );
  }, [fields, aggregationStrategy]);
  //

  const [show, setshow] = useState(values.aggregationStrategy == "3");
  const [CAFSlider, setCAFSlider] = useState(false);
  const [selectedItem, setselectedItem] = useState(null);

  const handleChangeDisappear = (e) => {
    setFieldValue("aggregationStrategy", e);
    e == "3" ? setshow(true) : setshow(false);
  };

  const clickCustomField = (indexItem) => {
    setCAFSlider(!CAFSlider);
    setselectedItem(indexItem);
  };

  const cardDisplay = (item, indexItem) => {
    return (
      <Card className="category-selection-cardSolo">
        <div className="category-selection-titleField">
          {item.fieldName[0] == "/" ? (
            <AddToolTip name={item.fieldName.substring(1)} />
          ) : (
            <AddToolTip name={item.fieldName} />
          )}
        </div>
        <div
          onClick={() => {
            clickCustomField(indexItem);
          }}
          className="category-selection-icon"
        >
          <FontAwesomeIcon icon={faCog} />
        </div>
        <div
          className="category-selection-cardType"
          style={{ overflow: "visible" }}
        >
          {item.type}
        </div>
        <div className="category-selection-exampleData">
          <AddToolTip name={item.datum} />
          {/* The variable to be substituted with the example data obtained from backend */}
        </div>
        <div className="category-selection-category">
          {item.operation?.trim() != "" ? item.operation : "not found"}
          {/* Aggregate Category to be displayed over here */}
        </div>
      </Card>
    );
  };

  const slideinDisplay = (selectedItem) => {
    return (
      CAFSlider && (
        <CustomAggregateFunction
          CAFSlider={CAFSlider}
          onCancel={() => setCAFSlider(false)}
          Fields={aggregateData}
          // setFields={setCustomFields}
          setCAFSlider={setCAFSlider}
          selectedItem={selectedItem}
          setFieldValue={setFieldValue}
        />
      )
    );
  };

  return (
    <>
      <div className="category-selection-container">
        <div className="category-selection-title">
          Pick your de duplication strategy
        </div>
        <div className="category-selection-listOfCategory form-check flex-row">
          <div>
            <input
              className="form-check-input category-selection-selectFirstRecord"
              type="radio"
              name="flexRadioDefault"
              id="category-selection-selectFirstRecord"
              value="1"
              checked={values.aggregationStrategy == "1"}
              onChange={() => {
                handleChangeDisappear("1");
              }}
            />
            <label for="category-selection-selectFirstRecord">
              Select first record
            </label>
          </div>
          <div>
            <input
              className="form-check-input category-selection-selectLastRecord"
              type="radio"
              name="flexRadioDefault"
              id="category-selection-selectLastRecord"
              value="2"
              checked={values.aggregationStrategy == "2"}
              onChange={() => {
                handleChangeDisappear("2");
              }}
            />
            <label for="category-selection-selectLastRecord">
              Select last record
            </label>
          </div>
          <div>
            <input
              className="form-check-input category-selection-selectCustomStrategy"
              type="radio"
              name="flexRadioDefault"
              id="category-selection-selectCustomStrategy"
              value="3"
              checked={values.aggregationStrategy == "3"}
              onChange={() => {
                handleChangeDisappear("3");
                setFieldValue(
                  "aggregationOperationEntities",
                  fields?.map((item) => {
                    return {
                      ...item,
                      operation: "First",
                    };
                  })
                );
              }}
            />
            <label for="category-selection-selectCustomStrategy">
              Select custom strategy
            </label>
          </div>
        </div>
        <div>
          {show ? (
            <div className="category-selection-cardContainer">
              {aggregateData?.length == "" && "There are no fields to show"}
              {aggregateData?.map(cardDisplay)}
            </div>
          ) : null}
          <div>{/* <pre>{JSON.stringify(customFields,null,2)} </pre> */}</div>
        </div>
      </div>
      {selectedItem != null ? slideinDisplay(selectedItem) : <></>}
    </>
  );
};

export default CategorySelectionContainer;
